const DOUBLE_LINE_BREAK = /(\r?\n){2,}/g

export default class UtilsMessage {

    // collapse double (or more) line breaks into single ones
    static collapseLineBreaks(message: string): string {
        return _.replace(message || '', DOUBLE_LINE_BREAK, '\n')
    }

    static convertEmailLinks(message: string): string {

        // for "[http://...] (http://...)" pattern
        const regexp = /\[(.*?)\]\((.*?)\)/gmis
        message = _.replace(message, regexp, (...match: any[]) => {
            const squareLink = match[1]
            const roundLink = match[2]

            // check if links are the same
            if (squareLink && roundLink && squareLink.trim() === roundLink.trim()) {
                return roundLink.trim()
            }
            return match[0] // no changes if links are different
        })

        // for "http://... <http://...>" pattern
        const regexp2 = /<((https?:\/\/|www)(.*?))>/gmis
        const matches = [...message.matchAll(regexp2)]

        _.forEach(matches, match => {
            if (!gd.utils.isValidURL(match[1])) {
                return
            }
            try {
                const url = new URL(match[1])
                message = _.replace(message, match[1] + " " + match[0], match[1])
                message = _.replace(message, url.host + " " + match[0], match[1])
                message = _.replace(message, match[1] + "" + match[0], match[1])
                message = _.replace(message, url.host + "" + match[0], match[1])
            } catch (err) {
                console.log(err)
            }
        })

        return message
    }
}
